<template lang="pug">
  .quotation-coupon(
    :class="{'quotation-coupon--valid': promoCode.value && promoCode.valid, 'quotation-coupon--invalid': promoCode.value && !promoCode.valid }"
  )
    .quotation-coupon__form
      label.quotation-coupon__form__label Possui um cupom de desconto?
      fieldset.quotation-coupon__form__fieldset
        input.quotation-coupon__form__input(name="ticket" id="ticket" ref="ticket" v-model="inputPromoCode" placeholder="Digite o código aqui" data-hj-whitelist)
        i.quotation-coupon__form__iconClear(@click="clearPromoCode" v-if="inputPromoCode")
        button.quotation-coupon__form__button(@click="applyPromoCode" :disabled="!inputPromoCode") Aplicar
      small.quotation-coupon__form__validation(v-if="inputPromoCode")
        template(v-if="promoCode.valid && promoCode.value") Cupom ativado com sucesso!
        template(v-if="promoCode.valid === false && promoCode.value") Cupom inválido
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'QuotationCoupon',
  data () {
    return {
      inputPromoCode: undefined
    }
  },
  created () {
    // Verifica se existe cupom na url ou existe ação Ciclic ativa com cupom ou seta undefined
    this.inputPromoCode = this.promoCode.value || undefined

    // Verifica se existe um promoCode, se sim, dispara métrica (GA)
    this.promoCode && this.promoCode.value && this.clickTracking()
  },
  watch: {
    inputPromoCode () {
      if (!this.inputPromoCode) {
        this.promoCode.value = ''
        // this.applyPromoCode()
      }
    }
  },
  computed: {
    ...mapState('quotation', ['promoCode'])
  },
  methods: {
    applyPromoCode () {
      const query = Object.assign({}, this.$route.query)

      query.promo_code = this.inputPromoCode
      this.$router.replace({ query })
    },
    clickTracking () {
      window.dataLayer.push({
        event: 'viagem-ciclic',
        gaEventAction: `${this.promoCode.value}`,
        gaEventCategory: 'validacao-promocode',
        gaEventLabel: `${this.promoCode.valid ? 'validado' : 'erro'}`
      })
    },
    clearPromoCode (el) {
      this.inputPromoCode = ''
      const query = { ...this.$route.query }
      delete query.promo_code
      this.$router.replace({ query })
    }
  }
}
</script>

<style lang="scss">
@import "~@/style/ui/variables";

.quotation-coupon {
  width: 100%;
  max-width: 420px;
  position: relative;

  @media screen and (max-width: 886px) {
    max-width: 384px;
  }

  &__form {
    &__label {
      font-family: Oscine;
      font-size: 20px;
      font-weight: bold;
      color: $color-tundora;

      @media screen and (min-width: 768px) {
        font-size: 26px;
      }

      @media screen and (min-width: 820px) {
        font-size: 28px;
      }
    }

    &__fieldset {
      border: none;
      margin-top: 8px;
      padding: 0;
      position: relative;
    }

    &__input {
      width: 100%;
      max-width: 175px;
      min-height: 40px;
      border-radius: 8px;
      background-color: $white;
      border: 1px solid $color-silver-sand;
      padding: 8px 16px;
      position: relative;
      text-transform: uppercase;

      @media screen and (min-width: 426px) {
        max-width: 210px;
      }

      @media screen and (min-width: 906px) {
        max-width: 243px;
      }

      &::placeholder {
        color: $color-manatee;
        font-size: 16px;
        font-family: Rubik;
        font-weight: normal;
        text-transform: none;
      }

      .quotation-coupon--valid & {
        border-color: #00cc67;
      }

      .quotation-coupon--invalid & {
        border-color: $red;
      }
    }

    &__iconClear {
      background-image: url('~@/assets/icons/close.svg');
      background-repeat: no-repeat;
      content: '';
      cursor: pointer;
      height: 11px;
      left: 150px;
      top: 15px;
      position: absolute;
      width: 11px;

      @media screen and (min-width: 426px) {
        left: 185px;
      }

      @media screen and (min-width: 906px) {
        left: 218px;
      }
    }

    &__button {
      width: 147px;
      height: 40px;
      background-color: transparent;
      border-radius: 30px;
      border: 1px solid $color-purple-heart;
      color: $color-purple-heart;
      text-transform: uppercase;
      font-size: 14px;
      font-family: Oscine;
      font-weight: bold;
      padding: 10px;
      margin-left: 24px;
      cursor: pointer;

      @media screen and (max-width: 886px) {
        width: 120px;
      }

      @media screen and (max-width: 392px) {
        width: 100px;
        margin-left: 13px;
      }

      &:disabled {
        opacity: .4;
      }

      .themeBB & {
        border-color: #0038a8;
        color: #0038a8;
      }
    }

    &__validation {
      left: 25px;
      position: absolute;
      top: calc(100% + 7px);
      color: $color-tundora;
      font-size: 12px;
      font-weight: 500;
      font-family: $rubik-font-family;

      &:before {
        width: 16px;
        height: 16px;
        left: -24px;
        content: '';
        background-repeat: no-repeat;
        position: absolute;
      }

      .quotation-coupon--valid &:before {
        background-image: url('~@/assets/icons/check-success.svg');
      }

      .quotation-coupon--invalid &:before {
        background-image: url('~@/assets/icons/check-error.svg');
      }
    }
  }
}
</style>
